import "./DisplayTextOverflowDynamic.scss";

import { ellipsis } from "ApiConstraints";
import { sanitizeValue, stripHtmlTags } from "helpers";
import React from "react";

interface DisplayTextOverflowDynamicProps {
  value: string | undefined;
}

export const DisplayTextOverflowDynamic: React.FC<DisplayTextOverflowDynamicProps> = ({ value }) => {
  value = sanitizeValue(value);
  value = stripHtmlTags(value);

  return (
    <span className="text-overflow-dynamic-container">
      <span title={value} className="text-overflow-dynamic-ellipsis global-tooltip-trigger">
        {value || ellipsis}
      </span>
    </span>
  );
};
